export default function snackbar(
  state = {
    snackbarMessage: null,
    variant: 'default',
    autoHideDuration: null,
    icon: undefined,
    hideCloseIcon: false,
  },
  action,
) {
  switch (action.type) {
    case 'SET_SNACKBAR_MODE':
      return {
        ...state,
        snackbarMessage: action.message,
        variant: action.variant,
        persistent: action.persistent,
        autoHideDuration: action.autoHideDuration,
        icon: action.icon,
        hideCloseIcon: action.hideCloseIcon,
        additionalText: action.additionalText,
      };

    case 'SET_SNACKBAR_CLOSED':
      return {
        ...state,
        snackbarMessage: null,
        persistent: false,
        variant: action.variant || 'default',
        autoHideDuration: null,
        icon: undefined,
      };

    default:
      return state;
  }
}
